export default __webpack_public_path__ + "3ff869ab802948aacee55a9b3fe67eb3.svg";